"use strict";
/*
 * Created on 25. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Indication of approve status.
 * @author Radek Beran
 */

var ApprovalStatusIndication;

(function (ApprovalStatusIndication) {
  ApprovalStatusIndication["InProgress"] = "InProgress";
  ApprovalStatusIndication["Approved"] = "Approved";
  ApprovalStatusIndication["ApprovedByAnotherUser"] = "ApprovedByAnotherUser";
  ApprovalStatusIndication["Waiting"] = "Waiting";
  ApprovalStatusIndication["Rejected"] = "Rejected";
  ApprovalStatusIndication["Late"] = "Late";
})(ApprovalStatusIndication = exports.ApprovalStatusIndication || (exports.ApprovalStatusIndication = {}));